/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FaceConfigurationDto } from "./Order/FaceConfigurationDto";
import { Flagman } from "./Flagman";
import { ConfigurationTemplateSupportedSizeDto } from "./ConfigurationTemplateSupportedSizeDto";
import { ConfigurationTemplateModelType } from "./ConfigurationTemplateModelType";
import { ConfigurationTemplateDormerOverhangDto } from "./ConfigurationTemplateDormerOverhangDto";
import { ConfigurationTemplatePriceCalculationDto } from "./ConfigurationTemplatePriceCalculationDto";
import { ModifyGroupIndex } from "./ModifyGroupIndex";
import { SectionFragmentType } from "./SectionFragmentType";

export class ConfigurationTemplateDto {
    id: string;
    name: string;
    templateFaceConfiguration: FaceConfigurationDto;
    templateFaceConfigurationId: string;
    flagman: Flagman;
    helpText: string;
    defaultWidth: number;
    defaultHeight: number;
    minimumWidth: number | null;
    maximumWidth: number | null;
    minimumHeight: number | null;
    maximumHeight: number | null;
    supportedSizes: ConfigurationTemplateSupportedSizeDto[];
    defaultAngle: number;
    organisationId: string | null;
    modelType: ConfigurationTemplateModelType;
    configurationTemplateDormerOverhang: ConfigurationTemplateDormerOverhangDto;
    configurationTemplatePriceCalculations: ConfigurationTemplatePriceCalculationDto[];
    strictSizeWarning: boolean;
    modifyGroupsAllowedToSeparate: ModifyGroupIndex[];
    sectionFragmentTypesAllowedToSeparate: SectionFragmentType[];
    modifiedOn: Date | null;
    createdOn: Date;
}
